import { SponsorPurchase } from '@vote4dance/judging-schema';

export const MAIN_SPONSOR_SLOT_ID = 'main-sponsor';
export const CLASS_SPONSOR_SLOT_ID = 'class-sponsor';

export const normalizeExternalUrl = (input?: string | null) => {
    const value = String(input || '').trim();
    if (!value) {
        return undefined;
    }

    if (/^https?:\/\//i.test(value)) {
        return value;
    }

    if (/^[a-z][a-z\d+\-.]*:/i.test(value)) {
        return undefined;
    }

    return `https://${value}`;
};

export const normalizeSponsorSlotIds = (input: unknown): string[] => {
    const parsed = (() => {
        if (!input) {
            return [];
        }

        if (Array.isArray(input)) {
            return input;
        }

        const stringValue = String(input).trim();
        if (!stringValue) {
            return [];
        }

        try {
            const jsonValue = JSON.parse(stringValue);
            if (Array.isArray(jsonValue)) {
                return jsonValue;
            }
        } catch {
            return stringValue.split(',').map((value) => value.trim()).filter(Boolean);
        }

        return [];
    })();

    return Array.from(new Set(
        parsed
            .map((value) => String(value || '').trim())
            .filter(Boolean)
    ));
};

export const isDisplayableSponsorPurchase = (purchase?: SponsorPurchase) => (
    Number((purchase as any)?.sponsor_item_active) === 1
);

export const getPurchaseSortValue = (purchase: SponsorPurchase) => {
    const purchaseId = Number(purchase?.sponsor_purchase_id || 0);
    if (!Number.isNaN(purchaseId) && purchaseId > 0) {
        return purchaseId;
    }

    const fallbackId = Number(purchase?.claim_token || 0);
    return Number.isNaN(fallbackId) ? 0 : fallbackId;
};

export const compareSponsorPurchases = (a: SponsorPurchase, b: SponsorPurchase) => (
    getPurchaseSortValue(b) - getPurchaseSortValue(a)
);
